export default __webpack_public_path__ + "static/aanbouw-desktop-141d60c95e15dd50ff818285cfdf2371.svg";